import { createAction, props, union } from '@ngrx/store';
import { RfrOrdItemI } from 'src/app/api/rfr-ord-search/rfr-ord-item.int';
import { RfrOrdSearchQueryI } from 'src/app/api/rfr-ord-search/rfr-ord-search.query.int';

export const load = createAction('[RFR ORD / Search] Get', props<{ query: RfrOrdSearchQueryI }>());
export const received = createAction('[RFR ORD / Search] Received', props<{ data: RfrOrdItemI[] }>());
export const reset = createAction('[RFR ORD / Search] Reset', props<Record<string, unknown>>());
export const switchView = createAction('[RFR OR / Query] Switch View', props<{
  tableView?: boolean;
}>());
export const query = createAction('[RFR ORD / Search] Query', props<{ query: string }>());
export const error = createAction('[RFR ORD / Search] Error', props<{ messageText: string }>());

const actions = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof actions;
